// // This function creates an <iframe> (and YouTube player) after the API code downloads.
// var player;
// function onYouTubeIframeAPIReady() {
// 	if (document.body.classList.contains('type--home')) {	
// 		player = new YT.Player('bannerVideo__player', {
// 			width: '720',
// 			height: '100%',
// 			videoId: document.querySelector('#bannerVideo__player').getAttribute('data-videoid'),
// 			playerVars: {
// 				controls: 0,
// 				modestbranding: 1,
// 				rel: 0,
// 				showinfo: 0,
// 				playsinline: 0,
// 			},
// 			// events: {
// 			// 	'onReady': onPlayerReady,
// 				// 'onStateChange': onPlayerStateChange
// 			// }
// 		});
// 	}
// }

ready(function(){
	// -- varibales --
	// const $showVideoBtn = document.querySelector('.btn--showVideo');
	// const $hideVideoBtn = document.querySelector('.btn--hideVideo');
	// const $cursor = document.querySelector('.cursor');
	// const $blockBannerVideo = document.querySelector('.blockBannerVideo');
	const $bg__video = document.querySelectorAll('.banner__video video');
	const $playPauseBtn = document.querySelector('.banner__video__controls .playPauseBtn');

	if ($playPauseBtn) {
		// -- listeners --
	  // $showVideoBtn.addEventListener('click', showVideo);
	  // $hideVideoBtn.addEventListener('click', hideVideo);
	  $playPauseBtn.addEventListener('click', updateVideoState);
		// -- functions --
		// function showVideo() {
		// 	(tarteaucitron.job = tarteaucitron.job || []).push('youtubeapi');
	  //   var allowBtns = document.getElementsByClassName("tarteaucitronAllow");
	  //   for (i = 0; i < allowBtns.length; i++) {
	  //     tarteaucitron.addClickEventToElement(allowBtns[i], function () {
	  //       tarteaucitron.userInterface.respond(this, true);
	  //     });
	  //   }
		// 	gsap.to(".banner__video .lightbox", 1, {'autoAlpha': 1, 'pointer-events': 'all', 'top': 0, 'ease': 'power4.out'});
		// 	$blockBannerVideo.scrollIntoView();
		// 	document.body.style.overflow = "hidden";
		// 	// $cursor.classList.remove('sm:block');
		// 	if (player) {
		// 		player.playVideo();
		// 	}
		// 	// window.scrollTo(0,0);
		// }
		// function hideVideo() {
		// 	gsap.to(".banner__video .lightbox", 1, {'autoAlpha': 0, 'pointer-events': 'none', 'top': '100%', 'ease': 'power4.out'});
		// 	document.body.style.overflow = "inherit";
		// 	// $cursor.classList.add('sm:block');
		// 	if (player) {
		// 		player.pauseVideo();
		// 	}
		// }
		function updateVideoState() {
			let state = $playPauseBtn.getAttribute('data-state');
			$bg__video.forEach((bgVideo) => {
				if (state == 'running') {
					$playPauseBtn.setAttribute('data-state', 'paused');
					bgVideo.pause();
				} else {
					$playPauseBtn.setAttribute('data-state', 'running');
					bgVideo.play();
				}				
			});
		}
	}
});